import { render, staticRenderFns } from "./Orientation.vue?vue&type=template&id=c5081afa&scoped=true&"
import script from "./Orientation.vue?vue&type=script&lang=js&"
export * from "./Orientation.vue?vue&type=script&lang=js&"
import style0 from "./Orientation.vue?vue&type=style&index=0&id=c5081afa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5081afa",
  null
  
)

export default component.exports